import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '💳',
      title: t('features.tap_title'),
      description: t('features.tap_desc')
    },
    {
      icon: '🧠',
      title: t('features.ai_title'),
      description: t('features.ai_desc')
    },
    {
      icon: '🔐',
      title: t('features.tamper_title'),
      description: t('features.tamper_desc')
    },
    {
      icon: '📈',
      title: t('features.analytics_title'),
      description: t('features.analytics_desc')
    },
    {
      icon: '📦',
      title: t('features.restock_title'),
      description: t('features.restock_desc')
    },
    {
      icon: '⚡',
      title: t('features.plug_title'),
      description: t('features.plug_desc')
    }
  ];

  return (
    <section id="features" className="bg-gradient-to-b from-slate-50 to-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">
            {t('features.title')}
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div key={index} className="rounded-2xl border bg-white p-6 chip">
              <div className="text-3xl">{feature.icon}</div>
              <h3 className="mt-3 font-semibold text-slate-900">{feature.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
